import { Component, Input, ChangeDetectionStrategy, SimpleChanges, ViewChild, OnInit, OnChanges, EventEmitter, Output } from '@angular/core';
import { ApexAxisChartSeries, ChartComponent } from 'ng-apexcharts';
import { IMiniChartConfig } from '../dashboard-card-summary.component';
import { IDashboardChartPallete } from '../../dashboard-card/dashboard-card.service';

const baseColor = 'var(--bs-primary)';
const grayColor = 'var(--bs-gray-400)';
const lightGrayColor = 'var(--bs-gray-200)';
const lightColor = 'var(--bs-light-primary)';

@Component({
  selector: 'app-mini-chart',
  templateUrl: './mini-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniChartComponent implements OnInit, OnChanges {
  @Input()
  public chartHeight: string;

  @Input()
  public isSelected: boolean;

  @Input()
  public label: string;

  @Input()
  public isCurrency: boolean;

  @Input()
  public isPercentage: boolean;

  @Input()
  public data: any[];

  @Input()
  public total: number;

  @Input()
  public availableMetrics: IMiniChartConfig[] = [];

  @Input()
  public isFakeData: boolean;

  @Input()
  public pallete?: IDashboardChartPallete;

  @Output()
  public selectMetric: EventEmitter<string> = new EventEmitter();

  @ViewChild('chart')
  private chartRef: ChartComponent;

  public chartOptions: any;

  public get series(): ApexAxisChartSeries {
    return [{
      name: this.label,
      data: this.data,
    }];
  }

  public get isTotalNumber(): boolean {
    return typeof this.total === 'number' && !isNaN(this.total);
  }

  public get chartBoxClasses(): string {
    const fakeColor = this.isSelected ? 'border-gray-600' : 'border-gray-300';
    return this.getColor(fakeColor, this.pallete?.borderColor, '', 'bg-white border-gray-300');
  }

  public get chartBottomColor(): string {
    return this.getColor(grayColor, this.pallete?.chartBgLightColor, '', lightGrayColor);
  }

  public ngOnInit(): void {
    this.chartOptions = this.getChartOptions(this.chartHeight);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isFakeData || changes.chartHeight || changes.pallete) {
      this.chartOptions = this.getChartOptions(this.chartHeight);
      this.chartRef?.updateOptions(this.chartOptions);
    }

    if (changes.data) {
      this.chartRef?.updateSeries(this.series);
    }
  }

  public getChartOptions(chartHeight: string): any {
    const colorAsVar = this.pallete?.chartBgColor ? `var(${this.pallete?.chartBgColor})` : '';
    const strokeColor = this.getColor(grayColor, colorAsVar,  baseColor, grayColor);
    const color = this.getColor(grayColor, this.pallete?.chartBgLightColor, lightColor, lightGrayColor);

    return {
      chart: {
        fontFamily: 'inherit',
        type: 'area',
        height: chartHeight,
        animations: {
          enabled: false
        },
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {},
      fill: {
        type: 'solid',
        opacity: 1,
      },
      stroke: {
        curve: 'smooth',
        show: true,
        width: 3,
        colors: [strokeColor],
      },
      tooltip: {
        enabled: false,
      },
      colors: [color],
      markers: {
        colors: [this.isFakeData ? grayColor : colorAsVar],
        strokeColors: [strokeColor],
        strokeWidth: 3,
      },
    }
  }

  private getColor(disabledColor: string, selectedColor: string | undefined, defaultSelectedColor: string, unselectedColor: string): string {
    if (this.isFakeData) {
      return disabledColor;
    } else if (this.isSelected) {
      return selectedColor || defaultSelectedColor;
    }
    
    return unselectedColor;
  }

}

